// En producción se recomienda usar el mismo dominio del frontend y proxy Nginx a la API
// Si no se define REACT_APP_API_BASE_URL en build, usamos "/api" y Nginx debe reenviar a aqua-api:4000
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '/api';
